"use client";

import { kAppConstants } from "@/src/definitions/appConstants.ts";
import { kClientPaths } from "@/src/lib/clientHelpers/clientPaths.ts";
import { cn } from "@/src/lib/utils.ts";
import Link from "next/link";
import { useContext } from "react";
import { GlobalStateContext } from "../contexts/global-state-context.tsx";
import { useSidebar } from "../ui/sidebar.tsx";

export interface IAppHeaderTitleProps {
  className?: string;
  alwaysShow?: boolean;
}

export function AppHeaderTitle(props: IAppHeaderTitleProps) {
  const { className, alwaysShow } = props;
  const sidebarHook = useSidebar();
  const globalState = useContext(GlobalStateContext);
  const showTitle = alwaysShow || !sidebarHook.open;
  const spaceName = globalState.listName ?? globalState.workspaceName;

  return (
    <div className={cn("min-w-0 flex-1 text-lg font-bold", className)}>
      {spaceName ? (
        <Link href={kClientPaths.app.index} className="block truncate">
          {spaceName}
        </Link>
      ) : showTitle ? (
        <Link href={kClientPaths.app.index} className="block truncate">
          {kAppConstants.name}
        </Link>
      ) : null}
    </div>
  );
}
